/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer logos generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import { Icon } from '../../icon/icon';
import type { LogoProps } from '../logo.types';

const Merrco = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 75 14.25"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#F26522"
      d="m 68.18345,0.012504 c -2.97591,0 -5.31413,1.337911 -6.35195,3.951214 -0.86276,-2.650815 -3.17598,-3.951214 -6.15189,-3.951214 -2.41324,0 -4.41386,0.91278 -5.61423,2.650814 v -2.47576 h -1.21287 c -1.38792,0 -2.72584,0.600184 -3.40104,1.763041 V 0.187558 H 40.6625 c -1.38793,0 -2.72584,0.600184 -3.40105,1.763041 V 0.187558 H 33.5103 v 5.66424 C 32.96013,2.325715 30.63441,0 26.88326,0 23.45721,0 20.88142,2.038126 20.15619,5.264118 v -0.6502 C 20.15619,1.913088 18.39315,0 15.24218,0 13.60418,0 12.11622,0.525161 11.0534,1.763042 10.4032,0.725223 9.26535,0 7.37727,0 5.73926,0 4.52639,0.6502 3.85118,1.487957 V 0.175054 H 0 V 14.141846 H 3.87619 V 5.901814 c 0,-1.838065 1.08783,-2.675823 2.2632,-2.675823 1.43794,0 1.9631,1.062827 1.9631,2.288204 v 8.615147 h 3.9137 V 5.88931 c 0,-1.838065 1.06283,-2.675822 2.23819,-2.675822 1.43794,0 1.98811,1.062826 1.98811,2.288203 v 8.615147 h 3.9012 V 9.127805 c 0.67521,3.100953 3.00092,5.164087 6.70206,5.164087 4.26381,0 6.12688,-2.550784 6.60203,-4.338833 v 4.163779 h 3.87619 V 6.677052 c 0,-1.938096 1.13785,-2.675822 3.05094,-2.675822 0.37511,0 0.96279,0.02501 1.26288,0.02501 v 10.078097 h 3.8762 V 6.664551 c 0,-1.938096 1.13785,-2.675822 3.05093,-2.675822 h 0.70022 c -0.35011,0.91278 -0.52516,1.963103 -0.52516,3.175976 0,4.738956 2.9509,7.077175 6.95213,7.077175 3.02593,0 5.23911,-1.312904 6.07687,-3.926207 1.03782,2.600799 3.37604,3.926207 6.32695,3.926207 4.02623,0 6.90212,-2.413242 6.90212,-7.127191 0.0875,-4.688941 -2.77586,-7.102182 -6.8146,-7.102182 z M 26.88326,3.050938 c 1.21287,0 2.36323,0.650199 2.52578,2.363226 h -5.26412 c 0.13754,-1.375423 1.27539,-2.363226 2.73834,-2.363226 z m 2.65082,6.301936 c -0.05,0.450139 -0.6252,1.813057 -2.65082,1.813057 -2.11315,0 -2.85088,-1.612995 -2.85088,-3.150968 H 33.5103 V 9.352874 Z M 58.28041,8.877728 c -0.25008,1.663011 -1.38793,2.288203 -2.62581,2.288203 -1.58799,0 -2.85087,-1.137849 -2.85087,-3.976222 0,-2.875883 1.23788,-4.001229 2.90089,-4.001229 1.3129,0 2.31321,0.6502 2.52577,2.363226 h 3.17598 c -0.075,0.550169 -0.12504,1.087834 -0.12504,1.638003 0,0.600185 0.05,1.162858 0.12504,1.688019 z m 9.90304,2.288203 c -1.638,0 -2.9259,-1.137849 -2.9259,-3.976222 0,-2.875883 1.2879,-4.001229 2.9259,-4.001229 1.68802,0 2.95091,1.13785 2.95091,4.001229 0,2.850877 -1.26289,3.976222 -2.95091,3.976222 z"
    />
  </svg>
);

export const MerrcoLogo = ({
  height = 48,
  width = 'auto',
  ...props
}: LogoProps) => {
  return (
    <Icon
      height={height}
      width={width}
      {...props}
      icon={Merrco}
      color={undefined}
      rotate={undefined}
      size={undefined}
    />
  );
};
